/* eslint-disable no-shadow */
const initialState = {
  laneCategoriesToggle: {
    digital: false,
    featured: false,
    private: false,
  },
  searchAndFiltersTab: '',
  showingEventsDirectory: '',
  dismissedSimulcastPrompt: false,
  eulaReviewBannerVisible: true,
  canLoadVdpPandaMfe: true, // must be true for initial state
};

export const state = {
  ...initialState,
};

export const mutations = {
  setLaneCategoryToggle(state, category = false) {
    state.laneCategoriesToggle[category] = !state.laneCategoriesToggle[category];
  },
  setSearchAndFiltersTab(state, tab = '') {
    if (tab) {
      state.searchAndFiltersTab = tab;
    }
  },
  setDefaultMarketplaceView(state) {
    state.laneCategoriesToggle = initialState.laneCategoriesToggle;
    state.searchAndFiltersTab = initialState.searchAndFiltersTab;
  },
  setShowingEventsDirectory(state, showingEventsDirectory = '') {
    state.showingEventsDirectory = showingEventsDirectory;
  },
  setDismissedSimulcastPrompt(state) {
    state.dismissedSimulcastPrompt = true;
  },
  setEulaReviewBannerVisible(state, isVisible) {
    state.eulaReviewBannerVisible = isVisible;
  },
  setCanLoadVdpPandaMfe(state, canLoad) {
    state.canLoadVdpPandaMfe = canLoad;
  },
};

/*
* Each action for a marketplace param should already be validated to be applicable
*/
export const actions = {
  updateLaneCategoryToggle({ commit }, { category = '' }) {
    commit('setLaneCategoryToggle', category);
  },
  updateSearchAndFiltersTab({ commit }, { tab = '' }) {
    commit('setSearchAndFiltersTab', tab);
  },
  resetMarketplaceView({ commit }) {
    commit('setDefaultMarketplaceView');
  },

  updateShowingEventsDirectory({ commit }, showingEventsDirectory = '') {
    commit('setShowingEventsDirectory', showingEventsDirectory);
  },

  dismissSimulcastPrompt({ commit }) {
    commit('setDismissedSimulcastPrompt');
  },

  updateEulaReviewBannerVisibility({ commit }, isVisible) {
    commit('setEulaReviewBannerVisible', isVisible);
  },

  updateCanLoadVdpPandaMfe({ commit }, canLoad) {
    commit('setCanLoadVdpPandaMfe', canLoad);
  },
};

export const getters = {
  laneCategoriesToggle: ({ laneCategoriesToggle }) => laneCategoriesToggle,
  searchAndFiltersTab: ({ searchAndFiltersTab }) => searchAndFiltersTab,
  showingEventsDirectory: ({ showingEventsDirectory }) => showingEventsDirectory,
  dismissedSimulcastPrompt: ({ dismissedSimulcastPrompt }) => dismissedSimulcastPrompt,
  eulaReviewBannerVisible: ({ eulaReviewBannerVisible }) => eulaReviewBannerVisible,
  canLoadVdpPandaMfe: ({ canLoadVdpPandaMfe }) => canLoadVdpPandaMfe,
};

const marketplaceView = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default marketplaceView;
